import { Typography } from '@design-system/components/typography/typography';
import { Row } from '@design-system/components/grid/grid';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { Skeleton } from '@mui/material';
import clsx from 'clsx';
import { useAddFromLibraryVM } from '@client/new/pages/workout/view-models/addFromLibrary.viewModel';
import { LibraryPicker } from '@client/new/pages/workout/components/addFromLibrary/addTemplatesFromLibraryModal';
import { VideoViewModel } from './video.viewModel';
import { Modal } from '@design-system/components/modal/modal';

type VideoModalProps = {
  onVideoPicked: ({
    uuid,
  }: {
    uuid: string;
    title?: string;
    thumbnailTimestampMs?: number;
  }) => void;
  isOpen: boolean;
  onClose: () => void;
  mode: VideoViewModel | null;
};

export const VideoModal = (p: VideoModalProps) => {
  const library = useAddFromLibraryVM({
    onClose: p.onClose,
    type: null,
    action: 'add',
    onAddVideo: p.onVideoPicked,
    onAddVideoFromSelection: (v) =>
      p.onVideoPicked({ uuid: v[0].uuid, title: v[0].title }),
    isMultipleChoice: false,
    skipProcessingStep: true,
    allowCustomThumbnails: true,
  });

  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      disableBackdropClick={true}
      footerClassName="p-0"
      modalClassName="w-full md:w-[800px]"
      modalContentClassName="overflow-hidden"
    >
      <div className="flex justify-between">
        <Row alignCenter>
          <Typography variant="headline">Add video</Typography>
        </Row>
      </div>

      <AsyncRenderer
        loadRender={
          <div className={clsx('w-full flex flex-col items-center gap-2')}>
            {Array.from({ length: 5 }, (_, i) => (
              <Skeleton
                variant="rounded"
                height={50}
                key={i}
                className="w-full"
              />
            ))}
          </div>
        }
        data={library}
        renderer={(vm) => <LibraryPicker {...vm} />}
      />
    </Modal>
  );
};
